var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/Box.tsx
import { forwardRef } from "react";
import MuiBox from "@mui/material/Box";
import { jsx } from "react/jsx-runtime";
var Box = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(MuiBox, __spreadProps(__spreadValues({}, props), { ref }));
});

// src/lib/Container.tsx
import MuiContainer from "@mui/material/Container";
import { jsx as jsx2 } from "react/jsx-runtime";
var Container = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx2(MuiContainer, __spreadProps(__spreadValues({}, rest), { children }));
};

// src/lib/Grid.tsx
import MuiGrid2 from "@mui/material/Grid2";
import { jsx as jsx3 } from "react/jsx-runtime";
var Grid = (args) => {
  return /* @__PURE__ */ jsx3(MuiGrid2, __spreadValues({}, args));
};

// src/lib/Stack.tsx
import MuiStack from "@mui/material/Stack";
import { jsx as jsx4 } from "react/jsx-runtime";
var Stack = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx4(MuiStack, __spreadProps(__spreadValues({}, rest), { children }));
};
export {
  Box,
  Container,
  Grid,
  Stack
};
